import * as React from 'react'
import { Theme, useTheme } from '@mui/material/styles'
import { FC } from 'react'

import Card from '@mui/material/Card'

const getStyles = (theme: Theme) => ({
  root: {
    border: 'solid 1px #d1d1d6',
    boxShadow: '0 2px 2px 0 #dddddd',
    marginBottom: theme.spacing(3),
    minWidth: '348px',
  },
})

interface Props {
  children: React.ReactNode
}

export const SalesFunnelCardWrapper: FC<Props> = (props) => {
  const { children } = props
  const styles = getStyles(useTheme())
  return (
    <Card raised={true} variant="elevation" sx={styles.root}>
      {children}
    </Card>
  )
}

SalesFunnelCardWrapper.displayName = 'EntityCardWrapper'
